import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Adaptive } from '../../model/adaptive';
import { AdaptiveRespuestaDTO } from '../../model/adaptive.respuesta.dto';
import { WelcomeService } from "../welcome/welcome.service";
import { Answer } from '../../model/answer';
import { AdaptiveResponse } from '../../model/adaptive.response';
import { CONFIG } from '../../constants/constants';
import { AdaptativePuntajeDTO } from '../../model/adaptive.puntaje.dto';
import { PuntajePrueba } from '../../model/puntajePrueba.dto';
@Injectable({
  providedIn: 'root'
})
export class AdaptativeService {

  /** Atributo que indica la sessión que se ha iniciado */
  public session: number;

  /**
   *
   * @param http Constructor servicio adaptativo.
   * @param _welcomeDataService
   */
  constructor(private http: HttpClient,
    private _welcomeDataService: WelcomeService) {
  }

  /**
   * Método que se encarga de incializar el exámen adaptativo.
   * @param user
   */
  public initializeExam(user: string, session: number, userName: string, token: string): Promise<AdaptiveResponse> {
    this.session = session;
    let adaptiveDTO = new Adaptive(this._welcomeDataService.data.shortName,
      this._welcomeDataService.data.sessions[session].subjects[0].subjectCode,
      user, null);
    console.log(adaptiveDTO);

    let _headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'token': token,
        'user': userName,
        'credencial': user,
        'sesion': (session + 1).toString()
      }
    );

    return this.http.post<AdaptiveResponse>(CONFIG.REST_END_POINT + 'siguienteItem/', JSON.stringify(adaptiveDTO),
      { headers: _headers }).toPromise();

  }

  /**
  * Método que se encarga de realizar la continuación del exámen.
  * @param user
  */
  public continuarExamen(user: string, session: number, userName: string, token: string): Promise<AdaptiveResponse> {
    this.session = session;

    let adaptiveDTO = new Adaptive(this._welcomeDataService.data.shortName,
      this._welcomeDataService.data.sessions[session].subjects[0].subjectCode,
      user, null);

    let _headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'token': token,
        'user': userName,
        'credencial': user,
        'sesion': (session + 1).toString()
      }
    );

    return this.http.post<AdaptiveResponse>(CONFIG.REST_END_POINT + 'recordarItem/', JSON.stringify(adaptiveDTO),
      { headers: _headers }).toPromise();

  }

  /**
   * Método que se encarga de obtener el siguiente ITEM en la prueba.
   * @param token
   * @param itemCode
   * @param answer
   * @param user
   */
  public nextItem(token: string, itemCode: string, answer: Answer, user: string, tipoItem: string, userName: string): Promise<AdaptiveResponse> {
    var respuestas = this.generarObjetoRespuesta(itemCode, answer, tipoItem);

    let adaptiveDTO = new Adaptive(this._welcomeDataService.data.shortName,
      this._welcomeDataService.data.sessions[this.session].subjects[0].subjectCode,
      user, respuestas);

    let _headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'token': token,
        'user': userName,
        'credencial': user,
        'sesion': (this.session + 1).toString()
      }
    );

    return this.http.post<AdaptiveResponse>(CONFIG.REST_END_POINT + 'siguienteItem/', JSON.stringify(adaptiveDTO),
      { headers: _headers }).toPromise();
  }

  /**
   * Método que se encarga de crear el objeto respuesta con todos sus elementos internos.
   * @param itemCode
   * @param answer
   */
  private generarObjetoRespuesta(itemCode: string, answer: Answer, tipoItem: string): AdaptiveRespuestaDTO[] {
    var respuestas: AdaptiveRespuestaDTO[] = [];
    var conteo = 1;
    if (tipoItem == 'ing_p2' || tipoItem == 'ing_p4' || tipoItem == 'ing_p7') {
      var separado = answer.valorRespuesta.split('|');
      for (let i = 0; i < separado.length; i++) {
        var itemResp = this.separarRespuestas(separado[i], tipoItem);
        let adaptiveRespuestaDTO = new AdaptiveRespuestaDTO(conteo, itemResp[0], itemResp[1]);
        respuestas.push(adaptiveRespuestaDTO);
        conteo++;
      }
    } else {
      let adaptiveRespuestaDTO = new AdaptiveRespuestaDTO(conteo, itemCode, answer.valorRespuesta);
      respuestas.push(adaptiveRespuestaDTO);
    }

    return respuestas;
  }

  /**
   * Método que se separar las respuestas dependiendo del tipo de item que se está almacenando.
   * @param answer
   * @param tipoItem
   */
  private separarRespuestas(answer: string, tipoItem: string): string[] {
    var salida: string[] = [];

    if (tipoItem == 'ing_p2') {
      salida = answer.split('*');
    }

    if (tipoItem == 'ing_p4' || tipoItem == 'ing_p7') {
      salida = answer.split('-');
    }

    return salida;
  }

  /**
   * Método que se encarga de consultar la totalidad de puntajes al terminar la prueba.
   */
  public consultarResultadoGlobal(user: string, session: number, userName: string, token: string): Promise<AdaptativePuntajeDTO> {
    this.session = session;
    let adaptiveDTO = new Adaptive(this._welcomeDataService.data.shortName,
      this._welcomeDataService.data.sessions[session - 1].subjects[0].subjectCode, user, null);

    let _headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'token': token,
        'user': userName
      }
    );

    return this.http.post<AdaptativePuntajeDTO>(CONFIG.REST_END_POINT + 'consultarPuntajeGlobal/', JSON.stringify(adaptiveDTO),
      { headers: _headers }).toPromise();
  }

  /**
   * Método que se encarga de guardar los datos de resultados de la prueba
   */
  public guardarPuntajePrueba(user: string, credencial: number, idPrueba: string, puntaje: number, token: string): Promise<any> {
    let score = new PuntajePrueba(credencial, idPrueba, puntaje);

    let _headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'token': token,
        'user': user
      }
    );

    return this.http.post(CONFIG.REST_END_POINT + 'setPuntajePrueba/', JSON.stringify(score),
      { headers: _headers }).toPromise();
  }

}
